import './management/css/management.scss';

console.log('Lukkari management script loaded 11:15');